import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { isEmpty, isMobile } from '@/commons/utils/functions';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { setNaat, getDocsSign, createValidationNaat, saveValidationNaat, getCredencialesNaat, saveFaceNaat } from "@/routes/api/views/vales";
import PzButton from "@/commons/forms/Buttons/PzButton";
import { Objeto } from "@/commons/forms/DigitalSings/Fad/EventoNaat";
import { CONFIGURATIONFront, CONFIGURATIONReverse, CONFIGURATIONFace } from "@/commons/forms/DigitalSings/Fad/Configuracion";
export default {
  name: "PzFad",
  components: {
    VueQrcode: VueQrcode,
    PzButton: PzButton
  },
  props: {
    route: {
      require: true,
      default: null,
      type: [String, URL]
    },
    redirect: {
      require: true,
      default: 'Prestamos',
      type: [String]
    }
  },
  data: function data() {
    return {
      frame_route: this.route,
      tipo: 1,
      intentos: 1,
      side: 0,
      imageId: '',
      imageFace: '',
      ocr: '',
      url: window.location.href,
      height: '600px',
      watch: {
        route: function route(value) {
          this.frame_route = value;
        },
        frame_route: function frame_route(value) {
          console.log('change form route');
          console.log(value);
        }
      },
      continuar: false,
      moduleParams: {
        credentials: '',
        configuration: CONFIGURATIONFront,
        side: 0,
        // 0 - front id, 1 - back id
        idData: false,
        // true - ocr, false - without this data
        idPhoto: false,
        // true - get imaghen face of id, false - without this data
        imageQuality: 0.5 // quality of image id, range 0 - 1

      },
      CREDENTIALSAcuant: '',
      CREDENTIALSFace: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['alias'])), {}, {
    esmobil: function esmobil() {
      return isMobile();
    }
  }),
  created: function created() {
    this.getCredenciales();
    window.addEventListener("message", this.eventos, false);
  },
  methods: {
    eventos: function eventos(event) {
      var _this = this;

      console.log('addEventListener ');
      console.log('tipo' + this.tipo);
      console.log('intentos' + this.intentos);
      if (event.data) switch (event.data.event) {
        case 'MODULE_READY':
          console.log('MODULE_READY');
          if (this.tipo == 1) this.initModule();else if (this.tipo == 2) this.initModuleFacetec();
          break;

        case 'PROCESS_ERROR':
          console.log('error');

          if (this.intentos < 3) {
            this.$store.dispatch('app/setMessage', 'Nuevo intento para la captura de información');
            this.intentos = this.intentos + 1;
            if (this.tipo == 1) this.initIframe();else if (this.tipo == 2) this.initModuleFacetec();else this.initModuleFirma();
          } else {
            this.handleRechazo();
          }

          break;

        case 'PROCESS_COMPLETED':
          console.log("Process completed");
          var result = event.data.data;
          console.log(result);

          if (this.tipo == 1) {
            if (this.side == 0) {
              sessionStorage.setItem('documentInstance', result.documentInstance);
              sessionStorage.setItem("idFront", result.id.image.data);
              this.side = 1;
              this.initModuleReverse();
            } else {
              this.crearValidacion({
                'imageFront': sessionStorage.getItem("idFront"),
                'imageBack': result.id.image.data,
                'ocr': result.idData.ocr,
                'foto': result.idPhoto,
                'alerts': result.idData.alerts
              });
            }
          } else if (this.tipo == 2) {
            this.saveFace({
              'imgLowQuality': result.lowQualityAuditTrail[0]
            });
          } else {
            setNaat(this.$route.params.alias, this.$route.params.loan).finally(function () {
              _this.continuar = true;
              _this.loading = false;

              _this.handleSend();
            });
          }

          break;

        case 'PROCESS_INIT':
          console.log("Process init");
          break;

        case 'PROCESS_ENDED':
          if (this.tipo == 3) {
            setNaat(this.$route.params.alias, this.$route.params.loan).finally(function () {
              _this.continuar = true;
              _this.loading = false;

              _this.handleSend();
            });
            console.log('proceso terminado firma');
          }

          break;

        case 'SIGNATURE_COMPLETED':
          if (this.tipo == 3) {
            setNaat(this.$route.params.alias, this.$route.params.loan).finally(function () {
              _this.continuar = true;
              _this.loading = false;

              _this.handleSend();
            });
            console.log('proceso de firma completo');
          }

          break;

        default:
          return;
      }
    },
    getCredenciales: function getCredenciales() {
      var _this2 = this;

      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      getCredencialesNaat().then(function (res) {
        _this2.CREDENTIALSAcuant = res.data.CREDENTIALSAcuant;
        _this2.CREDENTIALSFace = res.data.CREDENTIALSFace;
        _this2.moduleParams.credentials = res.data.CREDENTIALSAcuant;
      }).catch(function (error) {
        _this2.$store.dispatch('app/catchErrors', {
          _this: _this2,
          error: error
        });
      }).finally(function () {
        _this2.$store.dispatch('loader/down', {
          trigger: _this2.$options.name
        });
      });
    },
    initIframe: function initIframe() {
      var iframe = document.getElementById("naat");
      iframe.src = this.frame_route;
    },
    handleSend: function handleSend() {
      console.log('handleSend');
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      this.$router.push({
        name: 'FinFirma'
      });
      this.$store.dispatch('loader/down', {
        trigger: this.$options.name
      });
    },
    handleRechazo: function handleRechazo() {
      console.log('handleRechazo');
      var motivo = this.tipo == 1 ? this.$t('motivo_rechazo.acuant') : this.$t('motivo_rechazo.facetec');
      this.tipo = 1;
      this.intentos = 1;
      this.side = 0;
      window.removeEventListener("message", this.eventos, false);
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      this.$router.push({
        name: 'FadRechazo',
        params: {
          mensaje: motivo
        }
      });
      this.$store.dispatch('loader/down', {
        trigger: this.$options.name
      });
    },
    initModule: function initModule() {
      var iframe = document.getElementById("naat");
      console.log(this.moduleParams);
      iframe.contentWindow.postMessage(Objeto("INIT_MODULE", this.moduleParams), iframe.src);
    },
    initModuleReverse: function initModuleReverse() {
      var _this3 = this;

      console.log('initModuleReverse ');
      console.log(sessionStorage.getItem('documentInstance'));
      this.moduleParams.documentInstance = sessionStorage.getItem('documentInstance');
      this.moduleParams.side = 1;
      this.moduleParams.idData = true;
      this.moduleParams.idPhoto = true;
      this.moduleParams.credentials = this.CREDENTIALSAcuant;
      this.moduleParams.configuration = CONFIGURATIONReverse;
      setTimeout(function () {
        return _this3.initIframe();
      }, 0);
    },
    initModuleFacetec: function initModuleFacetec() {
      console.log('initModuleFacetec ');
      var iframe = document.getElementById("naat");
      var CREDENTIALS = this.CREDENTIALSFace;
      var CONFIGURATION = CONFIGURATIONFace;
      iframe.contentWindow.postMessage(Objeto("INIT_MODULE", {
        credentials: CREDENTIALS,
        configuration: CONFIGURATION
      }), iframe.src);
    },
    initModuleFirma: function initModuleFirma() {
      console.log('initModuleFirma ');
      this.getRoute(3);
      this.tipo = 3;
      this.intentos = 1;
      var iframe = document.getElementById("naat");
      iframe.src = this.frame_route;
    },
    getRoute: function getRoute() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tipo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tipo = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 2;
                console.log(_this4.$route.params);

                _this4.$store.dispatch('loader/up', {
                  trigger: _this4.$options.name
                });

                _context.next = 5;
                return getDocsSign({
                  'loan': _this4.$route.params.loan,
                  'tipo': tipo
                }).then(function (res) {
                  if (res.data.valid && !isEmpty(res.data.ruta)) {
                    _this4.frame_route = res.data.ruta;
                  }
                }).catch(function (error) {
                  console.log('error ruta');
                  console.log(error);

                  _this4.$store.dispatch('app/catchErrors', {
                    _this: _this4,
                    error: error
                  });
                }).finally(function () {
                  _this4.$store.dispatch('loader/down', {
                    trigger: _this4.$options.name
                  });
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    crearValidacion: function crearValidacion(result) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this5.$route.params);

                _this5.$store.dispatch('loader/up', {
                  trigger: _this5.$options.name
                });

                _context2.next = 4;
                return createValidationNaat(_this5.$route.params.loan, result).then(function (res) {
                  if (!res.data.valid) {
                    _this5.$store.dispatch('app/catchErrors', {
                      _this: _this5,
                      error: 'Problemas registro naat '
                    });
                  } else {
                    _this5.saveValidation();
                  }
                }).catch(function (error) {
                  console.log('error ruta');
                  console.log(error);

                  _this5.$store.dispatch('app/catchErrors', {
                    _this: _this5,
                    error: error
                  });
                }).finally(function () {
                  _this5.$store.dispatch('loader/down', {
                    trigger: _this5.$options.name
                  });
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    saveValidation: function saveValidation() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('saveValidationNaat');

                _this6.$store.dispatch('loader/up', {
                  trigger: _this6.$options.name
                });

                _context3.next = 4;
                return saveValidationNaat(_this6.$route.params.loan).then(function (res) {
                  if (!res.data.valid) {
                    _this6.handleRechazo();
                  } else {
                    _this6.getRoute();

                    _this6.tipo = 2;
                    _this6.intentos = 1;
                    var iframe = document.getElementById("naat");
                    iframe.src = _this6.frame_route;
                  }
                }).catch(function (error) {
                  console.log('error ruta');
                  console.log(error);

                  _this6.$store.dispatch('app/catchErrors', {
                    _this: _this6,
                    error: error
                  });
                }).finally(function () {
                  _this6.$store.dispatch('loader/down', {
                    trigger: _this6.$options.name
                  });
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    saveFace: function saveFace(result) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('saveFace');

                _this7.$store.dispatch('loader/up', {
                  trigger: _this7.$options.name
                });

                _context4.next = 4;
                return saveFaceNaat(_this7.$route.params.loan, result).then(function (res) {
                  if (!res.data.valid) {
                    _this7.handleRechazo();
                  } else {
                    _this7.initModuleFirma();
                  }
                }).catch(function (error) {
                  console.log('error ruta');
                  console.log(error);

                  _this7.$store.dispatch('app/catchErrors', {
                    _this: _this7,
                    error: error
                  });
                }).finally(function () {
                  _this7.$store.dispatch('loader/down', {
                    trigger: _this7.$options.name
                  });
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};